module.exports = __webpack_public_path__ + "static/media/avg12-logo-head.eb927867.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/avg12-logo-head.png
// module id = 390
// module chunks = 0